import { DashboardService } from "../Dashboard/dashboard.service"
import { DashboardDelegate } from "../Dashboard/dashboard.delegate"
import { HttpProviderFactory } from '../http/http-provider.factory';
import { SpinnerService } from '../SpinnerService/spinner.service';
import { IAppConfig } from '../http/types/IApplicationConfig';
import { AuthenticationService } from '../AuthenticationService/authentication.service';

export class DashboardServiceFactory
{
    static create(config: IAppConfig, spinnerService?: SpinnerService,
        authenticationService?: AuthenticationService
    ): DashboardService
    {
        const httpProvider = HttpProviderFactory.createHttpProvider(config, spinnerService);
        const delegate = new DashboardDelegate(httpProvider);

        return new DashboardService(delegate, authenticationService);
    }
}